import { spacing } from "@procore/core-react";

export const CONTENT_INSET = spacing.xxl + spacing.md;

export const CARD_SIDE_MARGIN = 10;
